import React from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from "react-router-dom";

const segments = [
	{ key: 'condos', label: 'Condo & Co-op Units' },
	{ key: 'houses', label: 'Houses' },
];

const SegmentSelector = ({ activeSegment, history }) => {

	const handleClick = (segmentKey) => {
		if (segmentKey !== activeSegment) {
			history.push(`/inventory-search/${segmentKey}`);
		}
	};

	return (
		<div style={{ display: 'flex', marginBottom: 12, borderBottom: '2px solid #e8e8e8' }}>
			{segments.map(seg => (
				<Button
					key={seg.key}
					onClick={() => handleClick(seg.key)}
					style={{
						borderRadius: 0,
						borderBottom: activeSegment === seg.key ? '3px solid #780F9E' : '3px solid transparent',
						color: activeSegment === seg.key ? '#780F9E' : '#646777',
						fontWeight: activeSegment === seg.key ? 600 : 400,
						fontSize: 15,
						textTransform: 'uppercase',
						padding: '8px 20px',
						minWidth: 0,
						marginBottom: -2,
					}}
				>
					{seg.label}
				</Button>
			))}
		</div>
	);
};

export default withRouter(SegmentSelector);
